import { all } from "redux-saga/effects";
import { LoginWatcher } from "../auth-saga";

export default function* authRootSaga() {
    yield all([
        LoginWatcher(),
    ])
}